export enum BrowserStorageKeys {
  LOGGED_IN = 'loggedIn',
  RETURN_URL = 'returnUrl',
}
